import React from "react";

export default function MyProfileAudienceReach({
  setShowConfirmInfModal,
  form,
  updateForm,
  error,
}) {
  const audienceGroups = [
    { key: "audience_0_12", label: "Kids (0 - 12)" },
    { key: "audience_13_17", label: "Teens (13 - 17)" },
    { key: "audience_18_24", label: "Young Adults (18 - 24)" },
    { key: "audience_25_34", label: "Adults (25 - 34)" },
    { key: "audience_35_44", label: "Middle-Aged (35 - 44)" },
    { key: "audience_45_54", label: "Late Middle-Aged (45 - 54)" },
    { key: "audience_55_64", label: "Pre-Retirees (55 - 64)" },
    { key: "audience_65plus", label: "Seniors (65+)" },
  ];

  const handleCheckboxChange = (key, checked) => {
    setShowConfirmInfModal(true);
    updateForm({
      [key]: checked ? "1" : "0",
      [`${key}_count`]: checked ? form[`${key}_count`] || "" : "",
    });
  };

  const handleCountChange = (key, value) => {
    setShowConfirmInfModal(true);
    updateForm({ [`${key}_count`]: value });
  };

  return (
    <>
      <div className="mb-8">
        <div className="mb-4">
          <h6 className="text-sm font-semibold text-gray-900">
            Audience <span className="text-red-500">*</span>
          </h6>
          <p className="text-xs text-gray-500 mt-1">
            Select age groups and enter specific audience counts
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {audienceGroups.map(({ key, label }) => (
            <div
              key={key}
              className={`${
                form[key] == 1 ? "border-green-500" : "border-gray-200"
              } "flex flex-col p-4 border  rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"`}
              onClick={() => handleCheckboxChange(key, form[key] != 1)}
            >
              <div className="flex items-center">
                <div className="relative flex items-center justify-center">
                  <input
                    checked={form[key] == 1}
                    onChange={() => {}}
                    type="checkbox"
                    className="peer h-5 w-5 appearance-none rounded border-2 border-gray-300 bg-white checked:border-green-800 checked:bg-green-700 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-offset-0"
                  />
                  <svg
                    className="absolute text-white opacity-0 peer-checked:opacity-100 pointer-events-none w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={4}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <span className="ml-3 text-sm text-gray-700 font-medium">
                  {label}
                </span>
              </div>
            </div>
          ))}
        </div>

        {error == 1 &&
          audienceGroups.every((group) => form[group.key] == 0) && (
            <div className="mt-3 flex items-center text-red-600">
              <span className="text-sm font-medium">
                Please select at least one audience age group and enter audience
                counts where applicable
              </span>
            </div>
          )}
      </div>

      <div className="mb-8">
        <div className="mb-4">
          <h6 className="text-sm font-semibold text-gray-900">
            Reach <span className="text-red-500">*</span>
          </h6>
          <p className="text-xs text-gray-500 mt-1">
            Choose your estimated audience reach
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {[
            { value: "<1K", label: "Less than 1K" },
            { value: "10-50", label: "10K - 50K" },
            { value: "50-250", label: "50K - 250K" },
            { value: "250-1M", label: "250K - 1M" },
            { value: "1M+", label: "1M+" },
          ].map(({ value, label }) => (
            <div
              key={value}
              className={`${
                form.reach === value ? "border-green-500" : "border-gray-200"
              } "flex items-center p-3 border rounded-lg hover:bg-gray-50 transition-colors"`}
            >
              <label className="flex items-center cursor-pointer w-full">
                <div className="relative flex items-center justify-center">
                  <input
                    checked={form.reach === value}
                    onChange={(e) => {
                      setShowConfirmInfModal(true);
                      updateForm({ reach: e.target.value });
                    }}
                    type="radio"
                    value={value}
                    className="peer h-5 w-5 appearance-none rounded-full border-2 border-gray-300 bg-white checked:border-green-800 checked:bg-green-700 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-offset-0"
                  />
                  <div className="absolute w-2 h-2 bg-white rounded-full opacity-0 peer-checked:opacity-100 pointer-events-none"></div>
                </div>
                <span className="ml-3 text-sm text-gray-700 font-medium">
                  {label}
                </span>
              </label>
            </div>
          ))}
        </div>

        {form.reach === "" && error == 1 && (
          <div className="mt-3 flex items-center text-red-600">
            <span className="text-sm font-medium">
              Please select your audience reach
            </span>
          </div>
        )}
      </div>
    </>
  );
}
